import axiosInstance from "../api";
import {
  GET_SEARCH_CHATS_USER,
  GET_CHAT_USER,
  GET_INVITATION,
  GET_NOTIFICATION,
  GET_POST_TYPE_CHATS,
  GET_NOTIFICATION_COUNT,
  GET_JOIN,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getNotificationlist = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `notification?index=0&size=30`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_NOTIFICATION,
        getnotificationlists: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getNotificationcount = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`count?type=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_NOTIFICATION_COUNT,
        getnotificationcount: response?.data?.response,
      });
      return;
    }
    // urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    // //urtoast(err.message, 2);
  }
};

export const getMensionlist = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `notification?index=0&size=10`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_NOTIFICATION,
        getnotificationlists: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getInvitationlist = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`team?type=8`);
    if (response?.data?.status) {
      dispatch({
        type: GET_INVITATION,
        getinvitationlists: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getJoinlist = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`team?type=10`);
    if (response?.data?.status) {
      dispatch({ type: GET_JOIN, getjoinlists: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getChatUserList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`chat?index=0&size=200`);
    if (response?.data?.status) {
      dispatch({
        type: GET_CHAT_USER,
        getchatuserlists: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getSerachChatUserlist = (search) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`chat?search=${search}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_SEARCH_CHATS_USER,
        serachallusers: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getPosttypeChatlist =
  (type, post_id, user_id, index, size) => async (dispatch) => {
    try {
      const calculatedSize = 15 * (index + 1) || 15;
      const response = await axiosInstance.get(
        `chat?type=${type}&post_id=${post_id}&user_id=${user_id}&index=${0}&size=${calculatedSize}`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_POST_TYPE_CHATS,
          getposttypechatlist: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const PostChat = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("chat", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPosttypeChatlist(data?.type, data?.post_id, data?.user_id));
      dispatch(getChatUserList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateInvitation = (data, navigate) => async (dispatch) => {
  const laung = localStorage.getItem("laung");
  try {
    const response = await axiosInstance.put("team/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getInvitationlist());
      if (data.status == 1) {
        navigate(`/${laung}/dashboard/manageteams`)
        window.location.reload()
      }
      return;
    } else {
      urtoast(response?.data?.response?.message, 2);
      navigate(`/${laung}/account/upgrademembership`)
    }

  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const hitPostChat = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("chat", data);
    if (response?.data?.status) {
      setLoading(false);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};
